
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Viktor Wächter, 80 ans, décédé le 5 avril 2020</b>
    <br />
    <br />
    <i>Son fils raconte:</i>
    <br />
    <p>
  «Le virus a frappé durement notre famille. Nous avons vécu une situation de
  détresse absolue. Ce qui nous est arrivé devrait faire prendre conscience à
  tout le monde de la dangerosité de ce virus. Le 18 mars, j’ai travaillé avec
  mon père pour la dernière fois dans le vignoble qu’il appréciait. Cinq jours
  plus tard, lui et ma mère ont ressenti les premiers symptômes. Au début, ils
  pensaient qu'il s'agissait d'une simple gastro-entérite. Le lendemain, c’est
  moi et ma femme qui avons été touchés.
    </p>
    <p>
  J’ai perdu le goût et l'odorat. Cela a commencé avec de violents maux de tête,
  puis une forte fièvre et des douleurs musculaires se sont manifestés. Pendant
  ce temps, l’état de santé de mes parents se détériorait rapidement. Le 29
  mars, nous les avons emmenés aux urgences de l'hôpital. Mon père a été admis
  aux soins intensifs en raison d'une détresse respiratoire extrême. Il n’a pas
  voulu être intubé: il disait aux médecins qu’il fallait attribuer les
  respirateurs aux jeunes générations, alors qu’il y avait assez d’appareils
  disponibles. Il était comme cela. Nous avons dû lui dire au revoir au
  téléphone. Sur le moment, c’était très douloureux d’entendre sa voix tout en
  sachant que c’était la dernière fois. Me rappeler que mon père a eu une vie
  épanouie, indépendante, m’aide. Pendant des années, il a été chef monteur à
  l'usine de câbles de Brugg, en Argovie. Il était très fier d’avoir contribué
  au développement du réseau électrique en Suisse. Le 5 avril, c’est lui qui a
  décidé de retirer son masque à oxygène. Il a préféré provoquer son départ. Ses
  poumons étaient alors très affaiblis. Il avait probablement compris qu’il ne
  pourrait plus jamais retourner dans son vignoble. Les circonstances de son
  décès restent traumatisantes pour ma mère. Physiquement, elle a vaincu le
  virus. Mais, psychologiquement, la douleur reste vive. Mes parents ont été
  mariés pendant soixante ans, ils ont été hospitalisés ensemble. Quand elle est
  rentrée à la maison, mon père n’était plus, mais sa tasse à café était
  toujours sur la table.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;